/**
 * @poc-to-production
 *
 * In-app PDF viewer for ACC submission package files.
 */
import { useAccPdfLoader } from "../hooks/useAccPdfLoader";
import { useDocumentViewerStore } from "../stores/documentViewerStore";

export function AccDocumentViewer() {
  useAccPdfLoader();
  const openDoc = useDocumentViewerStore(s => s.openDoc);
  const blobUrl = useDocumentViewerStore(s => s.blobUrl);
  const status = useDocumentViewerStore(s => s.status);
  const error = useDocumentViewerStore(s => s.error);
  const close = useDocumentViewerStore(s => s.close);

  if (!openDoc) return null;

  return (
    <div
      style={{
        position: "absolute",
        inset: 0,
        zIndex: 20,
        background: "#1a1a1a",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8,
          padding: "8px 12px",
          borderBottom: "1px solid var(--vera-border)",
          background: "var(--vera-panel-bg)",
          fontSize: 12,
        }}
      >
        <strong
          style={{ flex: 1, overflow: "hidden", textOverflow: "ellipsis" }}
        >
          PDF — {openDoc.fileName}
        </strong>
        {blobUrl && status === "ready" && (
          <a
            href={blobUrl}
            target="_blank"
            rel="noreferrer"
            style={openTabLink}
          >
            Open in tab
          </a>
        )}
        <button type="button" onClick={close} style={closeBtn}>
          Close
        </button>
      </div>
      <div style={{ flex: 1, minHeight: 0, position: "relative" }}>
        {status === "loading" && (
          <p style={{ padding: 16, color: "var(--vera-text-dim)" }}>
            Loading PDF…
          </p>
        )}
        {status === "error" && (
          <p style={{ padding: 16, color: "#f87171" }}>
            {error ?? "Failed to load PDF"}
          </p>
        )}
        {status === "ready" && blobUrl && (
          <object
            data={blobUrl}
            type="application/pdf"
            aria-label={openDoc.fileName}
            style={{
              display: "block",
              width: "100%",
              height: "100%",
              border: "none",
            }}
          >
            <iframe
              title={openDoc.fileName}
              src={blobUrl}
              style={{ border: "none", width: "100%", height: "100%" }}
            />
          </object>
        )}
      </div>
    </div>
  );
}

const openTabLink: Record<string, string | number> = {
  fontSize: 11,
  color: "#7fb3d5",
  textDecoration: "none",
  padding: "4px 8px",
  borderRadius: 4,
  border: "1px solid var(--vera-border)",
};

const closeBtn: Record<string, string | number> = {
  fontSize: 11,
  padding: "4px 10px",
  borderRadius: 4,
  border: "1px solid var(--vera-border)",
  background: "rgba(255,255,255,0.06)",
  color: "inherit",
  cursor: "pointer",
};
